<template>
  <div class="nx-list-action-content-schedules">
    <v-list-tile v-if="list && actionPublishCancel" @click.capture.stop="cancelPublish">
      <v-list-tile-action>
        <v-icon color="orange">auto_delete</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        {{ $t('message.metadata.contentSchedules.cancelPublish') }}
      </v-list-tile-content>
    </v-list-tile>
    <v-tooltip v-if="!list && actionPublishCancel" top>
      <template #activator="{on}">
        <v-btn v-on="on" @click.capture.stop="cancelPublish" class="ma-0" icon flat :loading="loading.publish">
          <v-icon color="orange" class="theme--light">auto_delete</v-icon>
        </v-btn>
      </template>
      <strong v-html="$t('message.metadata.contentSchedules.cancelPublish')"></strong>
    </v-tooltip>

    <v-list-tile v-if="list && actionUnpublishCancel" @click.capture.stop="cancelUnPublish">
      <v-list-tile-action>
        <v-icon color="orange">auto_delete</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        {{ $t('message.metadata.contentSchedules.cancelUnPublish') }} {{ actionUnpublishCancel }}
      </v-list-tile-content>
    </v-list-tile>
    <v-tooltip v-if="!list && actionUnpublishCancel" top>
      <template #activator="{on}">
        <v-btn v-on="on" @click.capture.stop="cancelUnPublish" class="ma-0" icon flat :loading="loading.unpublish">
          <v-icon color="orange" class="theme--light">auto_delete</v-icon>
        </v-btn>
      </template>
      <strong v-html="$t('message.metadata.contentSchedules.cancelUnPublish')"></strong>
    </v-tooltip>
  </div>
</template>

<script>
import api from '@/modules/content/api';
import toast from '@/modules/toast/services';
import { mapGetters } from 'vuex';

export default {
  name: 'nx-list-action-content-schedules',
  props: {
    id: {
      type: Number,
      required: true,
    },
    list: {
      type: Boolean,
    },
    actionUnpublishCancel: {
      type: Boolean,
    },
    actionPublishCancel: {
      type: Boolean,
    },
  },
  data() {
    return {
      loading: {
        publish: false,
        unpublish: false,
      },
    };
  },
  computed: {
    ...mapGetters(['context']),
  },
  methods: {
    async cancelPublish() {
      this.loading.publish = true;
      try {
        await api.cancelScheduledPublication(this.id);
        this.$emit('refreshItem');
        toast.notify('message.metadata.contentSchedules.canceledPublish');
      } catch (e) {
        console.error(e);
      }
      this.loading.publish = false;
    },
    async cancelUnPublish() {
      this.loading.unpublish = true;
      try {
        await api.cancelScheduledUnpublication(this.id);
        this.$emit('refreshItem');
        toast.notify('message.metadata.contentSchedules.canceledUnpublish');
      } catch (e) {
        console.error(e);
      }
      this.loading.unpublish = false;
    },
  },
};
</script>
